var map = {
	"./assessment-icon.svg": 1647,
	"./available-training-courses.svg": 1648,
	"./business-icon.svg": 1649,
	"./businesscase-pop.svg": 326,
	"./chk-white.svg": 199,
	"./close-popup.svg": 327,
	"./digital-organization.svg": 1650,
	"./disable-cursor.svg": 1651,
	"./education-analytics.svg": 751,
	"./intro-course.svg": 1652,
	"./logistic-intro-course.svg": 1653,
	"./loss-icon.svg": 1654,
	"./measure.svg": 752,
	"./my-trainging-h1.svg": 749,
	"./plant-flag.jpg": 1655,
	"./plant-flag.svg": 1656,
	"./prepare-execute.svg": 1657,
	"./search-icon.svg": 1658,
	"./skills-assessment.svg": 750,
	"./tech-adoption-icon.svg": 1659,
	"./training-course.svg": 753
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1646;